import iUser from '@/module/base/api/iUser';

export default {
    state: {
        userName: '',
        isAdmin: false,
        auth:[]
    },

    getters: {
        userName: state => state.userName,
        isAdmin: state => state.isAdmin,
        auth: state => state.auth,
    },

    mutations: {
        SET_USER: (state, user) => {
            state.userName = user.userName;
            state.isAdmin = user.superAdmin===1;
            state.auth = user.auth.sort((a, b) => a.sortNum - b.sortNum).map(e => {
                // menu_name 作为菜单识别的唯一标识
                e.menu_name = e.route_name + '.' + e.id;
                return e;
            });
        },
    },

    actions: {
        // 登陆
        Login({commit}, {userName, password}) {
            return new Promise((resolve) => {
                iUser.login(userName, password).then(res => {
                    if (res.role && res.role.menus) {
                        res.auth = res.role.menus
                    }
                    commit('SET_USER', res);
                    resolve();
                });
            });
        },

        // 登出
        Logout({commit}) {
            return new Promise((resolve) => {
                // 清除本地会员信息
                commit('SET_USER', {
                    userName: '',
                    isAdmin: false,
                    auth:[]
                });
                // 清除服务端信息 - 忽略异常
                iUser.logout().catch(() => {
                });
                // 同步返回
                resolve();
            })
        },

        // 获取用户信息
        getUserInfo({commit}) {
            return new Promise((resolve, reject) => {
                iUser.getUserInfo().then(res => {
                    if (res.role && res.role.menus) {
                        res.auth = res.role.menus
                    }
                    commit('SET_USER', res);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                });
            })
        }
    }
}
